import React from 'react';

const StaticInbox2 = ({ location }) => <div> Static Inbox 2</div>;

export default StaticInbox2;
